export default "__VITE_ASSET__BDxXHxw4__"